import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slices/auth";
import headerReducer from "./Slices/header";
import globalDialogsReducer from "./Slices/globalDialogs";
import loaderReducer from "./Slices/loader";
import  locationsReducer  from "./Slices/Location";
import  userSlice  from "./Slices/user";
import adminReducer from "./Slices/admin";
const store = configureStore({
  reducer: {
    auth: authReducer,
    header: headerReducer,
    globalDialogs: globalDialogsReducer,
    loader: loaderReducer,
    locations: locationsReducer,
    users: userSlice,
    admin: adminReducer,
  
  },
});
export default store;
